import { makeStyles } from '@material-ui/core/styles';
import { TextColors } from '@/utils/constants';

const darkTheme = {
  wrapper: {
    color: TextColors.light,
  },
};

const lightTheme = {
  wrapper: {
    color: TextColors.dark,
  },
};

const contentAlign = {
  right: {
    textAlign: 'right',
    '& .MuiCard-root': {
      textAlign: 'right',

      '& .card-logo': {
        '& .has-dimensions:not(.is-background) img': {
          left: 'unset',
          right: 0,
        },
        '& picture:not(.is-background):not(.has-dimensions)': {
          display: 'flex',
          justifyContent: 'flex-end',
        },
      },
    },

    '& .MuiCardActions-root': {
      justifyContent: 'right',
    },
  },
  center: {
    textAlign: 'center',
    '& .MuiCard-root': {
      textAlign: 'center',
      '& .card-logo': {
        '& .has-dimensions:not(.is-background) img': {
          right: 0,
          left: 0,
          margin: 'auto',
        },
        '& picture:not(.is-background):not(.has-dimensions)': {
          display: 'flex',
        },
      },
    },

    '& .MuiCardActions-root': {
      justifyContent: 'center',
    },
  },
};

const dropShadow = {
  noShadow: {
    '& .MuiCard-root': {
      boxShadow: 'none',
    },
  },
};

const useStyles = makeStyles(
  (muiTheme) => ({
    wrapper: {
      '&.dark-theme': darkTheme.wrapper,
      '&.light-theme': lightTheme.wrapper,
      width: '100%',
      backgroundSize: 'cover',
      overflow: 'hidden',
      padding: muiTheme.spacing(2, 0),
      margin: muiTheme.spacing(-2, 0),
    },
    container: {
      '&.MuiContainer-root': {
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        boxSizing: 'border-box',
        textAlign: 'left',
      },

      '&.content-align-right': contentAlign.right,
      '&.content-align-center': contentAlign.center,
      '&.no-drop-shadow': dropShadow.noShadow,
    },
    alignment: {
      alignItems: 'flex-start',
      alignContent: 'flex-start',
    },
  }),
  { name: 'GenCardCarousel' },
);

export default useStyles;
